import React from 'react';
// import Loadable from "@loadable/component";
import { trackCustomEvent } from "gatsby-plugin-google-analytics";
import CTAForm from "../components/CTAForm";
import Iframe from "../components/Iframe";
import CTASMBForm from "../components/CTASMBUpForm";
import CTASMBBottomForm from '../components/CTASMBBottomForm';
import { smbCategories } from './smbCategories';
import Video from '../components/Video';
import { getCtaTitle } from "../utils/getCtaTitle";
import { navigate } from "gatsby"
import { handleInPostLinks, collectChildrenToString } from './parserFunctions';
import InPostAuthorSection from '../components/Authors/inPostAuthorSection';

// const LoadableCTAForm = Loadable(() => import("../components/CTAForm"));
// const Iframe = Loadable(() => import("../components/Iframe"));

const faqAr = [];
const faqSet = new Set();
let allowLoadingFaqScript = true;

// const collectChildrenToString = (node, res) => {
//   let accum = res
//   if (node.data) {
//     accum += node.data;
//   }
//   if (node.children) {
//     for (let child of node.children) {
//       if (child.data) {
//         accum += child.data;
//       }
//       if (child.children) {
//         accum = collectChildrenToString(child, accum)
//       }
//     }
//   }
//   return accum;
// }



export const replaceMedia = (node, title, category, cta, init = true, author) => {
  if (node.attribs && node.attribs.class && node.attribs.class.includes("gatsby-image-wrapper")) {
    const hash = node.attribs.style.split(";").reduce((curr, next) => {
      const split = next.split(":");
      curr[split[0]] = split[1];
      return curr;
    }, {});
    // Swap
    hash["max-width"] = hash["width"];
    hash["width"] = "100%";
    node.attribs.style = Object.keys(hash).map((key) => `${key}:${hash[key]}`).join(";")
    return;
  }

  let ctaTitle = null;

  if (!init && node.name === 'form') {
    // add custom CTA forms
    if (node.attribs && (node.attribs.class.length > 0) && node.attribs.class.includes("forminator") && node.parent && node.parent.parent && node.parent.parent.name && (node.parent.parent.name === "td")) {
      return <></>;
      /*<></> */
    } else {
      if (category && category.name && smbCategories[category.name]) {
        if (global.formFlag) {
          return <div style={{ marginBottom: 55 }}>
            <CTASMBBottomForm cta={cta} title={ctaTitle || title} />
          </div>
        } else {
          global.formFlag = true;
          return <div style={{ marginBottom: 55 }}>
            <CTASMBForm cta={cta} title={ctaTitle || title} />
          </div>
        }
      }
      return <div style={{ marginBottom: 55 }}>
        <CTAForm cta={cta} title={ctaTitle || title} />
      </div>
    }
  } // handle inproper links

  else if (node.name === 'a' && node.attribs && node.attribs.href && node.attribs.href.charAt(0) === "/" && !node.attribs.href.includes("/learn")) {
    node.attribs.href = `/learn${node.attribs.href}`
  } else if (node.name === 'a' && node.attribs && node.attribs.href && node.attribs.href.includes("dnpgatsbywp.kinsta.cloud")) {
    node.attribs.href = node.attribs.href.replace("dnpgatsbywp.kinsta.cloud", "donotpay.com")
  } else if (node.name === 'img') {
    if (node.attribs) {

      // fix broken images (with extra space in the image src)
      // if (node.name === 'img' && node.attribs && node.attribs.src && node.attribs.src.includes(" ")) {
      //   node.attribs.src = node.attribs.src.replace(/ +/g, "");
      // }

      // fix broken images (with span elements within the src attribute)
      // if (node.name === 'img' && node.attribs && node.attribs.src && node.attribs.src.includes("span")) {
      //   node.attribs.src = node.attribs.src.replace(/<\/span>+/g, "").replace(/<span>+/g, "");
      // }
      // if (node.attribs.loading) {
      //   node.attribs.loading = "lazy";
      // }
      if (node.attribs.src && node.attribs.src.length) {

        // fix broken images (with extra space in the image src)
        if (node.attribs.src.includes(" ")) {
          node.attribs.src = node.attribs.src.replace(/ +/g, "");
        }

        // fix broken images (with span elements within the src attribute)
        if (node.attribs.src.includes("span")) {
          node.attribs.src = node.attribs.src.replace(/<\/span>+/g, "").replace(/<span>+/g, "");
        }

        // serve images from cdn
        if (node.attribs.src.includes("dnpgatsbywp.kinsta.cloud")) {
          node.attribs.src = node.attribs.src.replace("dnpgatsbywp.kinsta.cloud", "dvo14rqtr1m20.cloudfront.net")
        }

      }

    }

  } else if (node.name === 'iframe' && node.attribs) {
    if (init) {
      return <></>;
      /*<></> */
    } else {
      return <Iframe allowFullScreen={node.attribs.allowFullScreen} allow={node.attribs.allow} src={node.attribs.src} title={node.attribs.title} width={node.attribs.width} height={node.attribs.height} />
    }
  }


  // if (node.name === "p" && node.data && node.data.includes("https://www.youtube.com/watch")) {
  if (node.name === "p" &&
    node.children &&
    node.children[0] &&
    node.children[0].type &&
    node.children[0].type === "text" &&
    node.children[0].data.includes("https://www.youtube.com/watch")) {
    const url = node.children[0].data
    let urlEmbed = ""
    if (url.includes("watch?v=")) {
      urlEmbed = url.replace(/\n/g, "").replace("watch?v=", "embed/").trim()
    } else if (url.includes("&v=")) {
      const urlParams = url.split("&")
      let videoID = ""
      urlParams.forEach((par) => {
        if (par[0] === "v") {
          videoID = par.replace("v=", "")
        }
      })
      urlEmbed = `https://www.youtube.com/embed/${videoID}`
    }
    const strAr = urlEmbed.split("https")
    const sourceUrl = `https${strAr[1]}`
    return <> {strAr[0]} <Video videoSrcURL={sourceUrl} /> </>
  }


  if (node.name === "a") {
    const linkReplaceObject = handleInPostLinks(node);
    if (linkReplaceObject) return linkReplaceObject
  }


  // if (
  //   node.name === 'a' &&
  //   node.attribs &&
  //   node.attribs.href &&
  //   node.attribs.href.includes("donotpay.com") &&
  //   !node.attribs.href.includes("learn") &&
  //   !node.attribs.href.endsWith(".com") &&
  //   !node.attribs.href.endsWith(".com/")
  // ) {

  //   const btnText = collectChildrenToString(node, "");

  //   return <button
  //     style={{
  //       backgroundColor: "transparent",
  //       backgroundRepeat: "no-repeat",
  //       border: "none",
  //       cursor: "pointer",
  //       overflow: "hidden",
  //       outline: "none",
  //       // color: "#e01efe",
  //       color: "#e01efee8",
  //       fontWeight: "inherit",
  //       textDecoration: "underline",
  //       padding: 0,
  //       fontSize: "inherit",
  //     }}
  //     onClick={() => {
  //       const ctaUrl = node?.attribs?.href || "https://donotpay.com/login/"
  //       navigate(ctaUrl)
  //     }}
  //   >
  //     {btnText}
  //   </button >
  // }

  //   // external links to be opened in new tab
  //   if (node.name === 'a' && node.attribs && node.attribs.href && !node.attribs.href.includes("donotpay.com")) {
  //     node.attribs.target = "_blank";
  //   }

  //   // if (node.name === 'a' && node.attribs && node.attribs.href && node.attribs.href.includes("donotpay.com") && !node.attribs.href.endsWith("/")) {
  //   //   node.attribs.href = node.attribs.href + "/";
  //   // }
  // }

  //add 'Web Link All' Google Tag:
  if (node.name === 'a' && node.attribs && node.attribs.href && node.attribs.href.includes("donotpay.com") &&
    !node.attribs.href.includes("/learn")) {
    node.attribs.onClick = () => {
      // trackCustomEvent({
      //   category: "In-content Web Link",
      //   action: "click",
      //   label: "Link Click",
      // });
    }
  }

  // swap all <b> tags for <strong> tags as per CD request 
  if (node.name === "b") {
    node.name = "strong";
  }

  // to mark section as FAQ module it should have faq secion id <section id="faqSection"></section>
  if (node.name === "section" && node.attribs && node.attribs.id === "faqSection") {
    let isFAQ = false;

    for (let i = 0; i < node.children.length; i++) {
      const ch = node.children[i];
      if (ch.type === "tag" && ch.name === "h2" && ch.children[0] && ch.children[0].data &&
        (ch.children[0].data.toLowerCase().includes("faq") || ch.children[0].data.toLowerCase().includes("frequently asked"))
      ) {
        isFAQ = true;
        break
      }
    }

    if (isFAQ) {
      try {
        const jsonLD = {
          "@context": "https://schema.org",
          "@type": "FAQPage",
          "mainEntity": []
        }
        node.children.forEach(child => {
          if (child.type === "tag" && child.name === "h3") {
            const name = child.children[0].data
            while (child.name !== "p") {
              if (child.next === null) break;
              child = child.next
            }
            if (child.name !== "p") {
              console.log("Error traversing faq element");
              return;
            }
            let ans = ""

            if (child.children) child.children.forEach((ch) => {
              if (ch.type === "tag") {
                if (ch.name === "a") {
                  if (ch.attribs.href) ans += `<a href="${ch.attribs.href}">${ch.children[0].data}</a>`
                } else {
                  ans += ch.children[0].data
                }
              } else if (ch.type === "text") {
                ans += ch.data
              }
            })
            if (name.length > 0 && ans.length > 0) {
              jsonLD.mainEntity.push({
                "@type": "Question",
                "name": name,
                "acceptedAnswer": {
                  "@type": "Answer",
                  "text": `${ans}`
                }
              })
            } else {
              console.log("Error loading one of the faq fields");
            }
          }
        })

        if (typeof document !== "undefined") {
          const checkIfInstalled = document.querySelectorAll('script[type="application/ld+json"]');
          if (checkIfInstalled.length === 0) {
            const faqScript = document.createElement("script");
            faqScript.type = "application/ld+json"
            faqScript.class = "faq"
            faqScript.innerHTML = JSON.stringify(jsonLD);
            document.head.appendChild(faqScript);
            console.log(jsonLD);
          }
        }

      } catch (error) {
        console.log("Error parsing FAQ section");
        console.log(error);
      }

    }

  }

  // to parse h2 Titles and Paragraphs into json-ld script for FAQ
  if (category?.name === "Frozen Crypto Funds" && allowLoadingFaqScript) {

    try {

      if (node?.type === "tag" && node?.name === "h2") {
        if (node?.children && (node?.children[0]?.children || node?.children[1]?.children || node?.children[0]?.data)) {

          const ind = node.children[0]?.children ? 0 : 1;

          if ((node?.children && node?.children[ind] && node?.children[ind]?.children) || node?.children[0]?.data?.trim()) {

            const name = collectChildrenToString(node, "");

            if (name?.trim()?.length > 0) {
              let answer = "";

              let nodeCopy = { ...node }

              while (nodeCopy.next && nodeCopy.next.name !== "h2" && nodeCopy !== null) {
                let curAnswer = ""
                nodeCopy = { ...nodeCopy.next }
                if (nodeCopy.name === "p") {
                  let pData = ""
                  if (nodeCopy.children) for (let ch of nodeCopy.children) {
                    if (ch?.type === "tag" && ch?.children[0]?.data) {
                      if (ch?.name === "a") {
                        if (ch?.attribs?.href) pData += `<a href="${ch.attribs.href}">${ch.children[0].data}</a>`
                      } else {
                        pData += ch.children[0].data
                      }
                    } else if (ch.type === "text" && ch.data) {
                      pData += ch.data
                    } else if (ch.type === "tag") {
                      if (ch.children) {
                        for (let tagChild of ch.children) {
                          if (tagChild.name === "a" && tagChild.children[0].data) {
                            if (tagChild?.attribs?.href) pData += `<a href="${tagChild.attribs.href}">${tagChild.children[0].data}</a>`
                          } else {
                            if (tagChild.data) pData += tagChild.data
                          }
                        }
                      }
                    } else {
                      console.log(ch, "Edge case in p element");
                    }
                  }
                  if ((nodeCopy?.next?.name === "table" || nodeCopy?.next?.next?.name === "table") &&
                    (pData?.replace(/\n/g, "").trim().charAt(pData.replace(/\n/g, "").trim().length - 1) === ":")) {
                    continue;
                  } else {
                    if (pData && pData.trim()) curAnswer = "<p>" + pData + "</p>"
                  }
                } else if (nodeCopy.name === "ul" || nodeCopy.name === "ol") {
                  curAnswer += nodeCopy.name === "ul" ? "<ul>" :
                    (nodeCopy?.attribs?.start ? `<ol start="${nodeCopy.attribs.start}">` : "<ol>")
                  if (nodeCopy.children) for (let child of nodeCopy.children) {
                    if (child.name === "li") {
                      // if (child.data) 
                      let liData = ""
                      for (let liChild of child.children) {
                        if (liChild.name === "a" && liChild.children && liChild.children[0].data) {
                          if (liChild.attribs.href) liData += `<a href="${liChild.attribs.href}">${liChild.children[0].data}</a>`
                        } else if (liChild.data && liChild.data?.trim()) {
                          liData += liChild.data
                        } else if (liChild.name === "strong") {
                          for (let strChild of liChild.children) {
                            if (strChild.name === "a" && strChild.children && strChild.children[0].data) {
                              if (strChild.attribs.href) liData += `<a href="${strChild.attribs.href}">${strChild.children[0].data}</a>`
                            } else {
                              if (strChild?.data?.trim()) {
                                liData += strChild.data.trim()
                              }
                            }
                          }
                        } else if (liChild.children) {
                          for (let subCh of liChild.children) {
                            if (subCh?.data?.trim()) {
                              liData += subCh.data.trim()
                            }
                          }
                        } else {
                          if (liChild.data !== "\n" && liChild.data?.trim().length > 0) {
                            console.log("Edge case in li element", liChild);
                          }
                        }
                      }
                      if (liData) curAnswer += `<li>${liData}</li>`
                    }
                  }
                  curAnswer += nodeCopy.name === "ul" ? "</ul>" : "</ol>"
                } else if (nodeCopy.name === "h3") {
                  let h3Data = ""
                  if (nodeCopy.children) for (let h3Child of nodeCopy.children) {

                    if (h3Child.datah) h3Data += h3Child.data;
                    if (h3Child.children) for (let ch of h3Child.children) {
                      h3Data += ch.data
                    }
                  } else {
                    console.log(nodeCopy);
                  }
                  if (h3Data) curAnswer += `<h3>${h3Data}</h3>`

                }
                // else if (nodeCopy.name === "table") {
                //   faqSet.add(name)
                //   break;
                // } 
                if (curAnswer) answer += curAnswer
                //else if (node.type === "text" && node.data === "\n") {
                // if (answer) answer += "\n";
                //}
              }

              if (name && answer && !faqSet.has(name)) {
                faqAr.push({
                  "@type": "Question",
                  "name": name,
                  "acceptedAnswer": {
                    "@type": "Answer",
                    "text": `${answer}`
                  }
                })
                faqSet.add(name)
              }
            }
          }
        }

      }
    } catch (error) {
      console.log(`%c "Parser Error, FAQ not loaded"`, 'background: #ddd; color: red; padding: 2px');
      allowLoadingFaqScript = false;
      console.log(error);
    }
  }

  if (node.name === "fin") {
    if (typeof document !== "undefined") {
      const faqScript = document.querySelectorAll('script[type="application/ld+json"]');
      const jsonLD = {
        "@context": "https://schema.org",
        "@type": "FAQPage",
        "mainEntity": faqAr
      }
      if (faqScript.length === 0 && jsonLD.mainEntity.length > 0) {
        const faqScript = document.createElement("script");
        faqScript.type = "application/ld+json"
        faqScript.class = "faq"
        faqScript.innerHTML = JSON.stringify(jsonLD);
        document.head.appendChild(faqScript);
        console.log(jsonLD);
        allowLoadingFaqScript = false;
      }
    }
  }

  if (!init) {
    ctaTitle = getCtaTitle(category.name)
    if (node.name === "wbr") {
      if (node.attribs.id === "ctaform") {
        if (category && category.name && smbCategories[category.name]) {
          return <div style={{ marginBottom: 55 }}>
            <CTASMBForm cta={cta} title={ctaTitle || title} />
          </div>
        } else {
          return (<div style={{ marginBottom: 55, marginTop: 55 }}>
            <CTAForm cta={cta} title={ctaTitle || title} />
          </div>
          )
        }
      }
    }

    if (node.name === "fin") {
      if (category && category.name && smbCategories[category.name]) {
        return <div style={{ marginBottom: 20 }}>
          {author && <InPostAuthorSection
            name={author?.name}
            description={author?.bio}
            expertise={author?.expertise}
            avatar={author?.avatar}
            role={author?.role}
            authorsPage={`../authors/${author?.slug}/`}
          />}
          <CTASMBBottomForm cta={cta} title={ctaTitle || title} />
        </div>
      } else {
        return (<div style={{ marginBottom: 20, marginTop: 20 }}>
          {author &&
            <InPostAuthorSection
              name={author?.name}
              description={author?.bio}
              expertise={author?.expertise}
              avatar={author?.avatar}
              role={author?.role}
              socialMedia={author?.socialMedia}
              authorsPage={`../authors/${author?.slug}/`} />}

          <CTAForm cta={cta} title={ctaTitle || title} />
        </div>)
      }
    }
  }
};
